import api from "./api";
import firebase from "firebase";
import "firebase/auth";

const firebaseConfig = {
  apiKey: "AIzaSyDuMjXoX9U_0wkIjqFQeiDZhwwRgv9z8BM",
  authDomain: "tbm-certifications.firebaseapp.com",
  projectId: "tbm-certifications",
  storageBucket: "tbm-certifications.appspot.com",
  messagingSenderId: "500507656916",
  appId: "1:500507656916:web:3e1486c976d847151c3141",
  measurementId: "G-BB7H04GEVT",
};

// Initialize Firebase
if (firebase.apps.length < 1) {
  firebase.initializeApp(firebaseConfig);
}

const getToken = () => auth.currentUser.getIdToken(true);

const auth = firebase.auth();

const AuthService = {
  signIn: (email, password) =>
    firebase
      .auth()
      .signInWithEmailAndPassword(email, password)
      .then((user) => {
        return getToken().then((token) => {
          api.defaults.headers.common["Authorization"] = token;
          return user;
        });
      }),
  userLoggedIn: (success, error) =>
    auth.onAuthStateChanged((user) => {
      if (user) {
        getToken().then((token) => {
          api.defaults.headers.common["Authorization"] = token;
          if (success) success(user);
        });
      } else {
        error();
      }
    }),
  signOut: () => auth.signOut(),
  signUp: (correo, password) =>
    auth.createUserWithEmailAndPassword(correo, password),
  recoverPassword: (email) => auth.sendPasswordResetEmail(email),
  getToken: () => auth.currentUser.getIdToken(true),
  verifyEmail: () => auth.currentUser.sendEmailVerification(),
  updateEmail: (email) => auth.currentUser.updateEmail(email),
  updatePassword: (currentPassword, newPassword) => {
    const user = auth.currentUser;
    const credential = firebase.auth.EmailAuthProvider.credential(
      user.email,
      currentPassword
    );
    return user
      .reauthenticateWithCredential(credential)
      .then(() => user.updatePassword(newPassword));
  },
  setToken: (token) => (api.defaults.headers.common["Authorization"] = token),
};

export default AuthService;
